import { ArrowBack, Close } from "@mui/icons-material";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Dialog,
  DialogContent,
  Grid,
  IconButton,
  // TextField,
  Tooltip,
} from "@mui/material";
import { useMediaQuery, useTheme } from "@mui/system";
import axios from "axios";
import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import { Helmet } from "react-helmet";
import {
  ExpandedIcon,
  HandClapImage,
  HomeIcon,
  NoAnnoucementImage,
  PointerIcon,
  SmallStarIcon,
  SmallStarIconGray,
  VerifyIcon,
} from "../../assets/images/FrankIcons";
import apiServices from "../../services/RequestHandler";
import { strings } from "../../Store/Localization";
import CustomButton from "../../UiComponent/CustomButton";
import CustomFooter from "../../UiComponent/CustomFooter";
import DraggableDialog from "../../UiComponent/DraggableDialog";
import GoogleAutocompleteField from "../../UiComponent/GoogleAutocompleteField";
import NewHeader from "../../UiComponent/NewHeader";
import Toast from "../../UiComponent/Toast/Toast";
import {
  apiKey,
  defaultLabelColors,
  no_image_url,
  no_profile_image,
} from "../../utils/constants";
import noImageTwo from "../../assets/images/FrankIcons/noImageAvailable.png";
import {
  currencyFormat,
  handleLocalize,
  numberFormatWithoutCurrencyFixedOne,
} from "../../utils/helper";
import { getDataFromLocalStorage } from "../../utils/LocalStore.util";
import AuthAction from "../Auth/AuthAction";
import { addDoc, collection } from "firebase/firestore";
import { firestoreDB } from "../../utils/notificationListner";
import FrankConstants from "../../utils/FrankConstants";
import { RootState } from "../../Store";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import InputField from "../../UiComponent/TextFeild";
import CustomDialogBox from "../../UiComponent/CustomDialogBox";
import { Rating } from "react-simple-star-rating";
import CustomMobileFooter from "../../UiComponent/CustomMobileFooter";
import MobileResponsive from "../LandingPage/MobileResponsive";
import { Squircle } from "corner-smoothing";
import AnnoucementCard from "../../UiComponent/AnnoucementCard";

function AllAnounces(props: any) {
  const { classes } = props;
  const navigate = useNavigate();
  const theme = useTheme();

  // const xs = useMediaQuery(theme.breakpoints.up("xs"));
  // const md = useMediaQuery(theme.breakpoints.up("md"));
  // const lg = useMediaQuery(theme.breakpoints.up("lg"));
  // const xl = useMediaQuery(theme.breakpoints.up("xl"));
  // const sm = useMediaQuery(theme.breakpoints.up("sm"));
  // const isBetween = useMediaQuery("(min-width:1025px) and (max-width:1057px)");

  const screen_1024 = useMediaQuery(theme.breakpoints.up(1025));
  const screen_600 = useMediaQuery(theme.breakpoints.up(601));
  const [showMore, setShowMore] = useState(false);
  const [height, setHeight] = useState("0px");
  const contentRef = useRef<any>(null);

  useEffect(() => {
    setHeight(showMore ? `${contentRef?.current?.scrollHeight}px` : "60px"); // 60px = about 3 lines
  }, [showMore]);
  const [inputValueForOrigin, setInputValueForOrigin] = useState("");
  const [inputValueForDestination, setInputValueForDestination] = useState("");
  // eslint-disable-next-line
  const [originLocationForMap, setOriginLocationForMap] = useState({});
  const selector = useSelector((state: RootState) => state.mainApp);

  // let user = getDataFromLocalStorage("user");
  // eslint-disable-next-line
  const [destinationLocationForMap, setDestinationLocationForMap] = useState(
    {}
  );
  const [state, setState] = React.useReducer(
    (state: any, newState: any) => ({ ...state, ...newState }),
    {
      announes: "All",
      initilalTotalFeedBack: 3,
      image_box: false,
    }
  );

  useEffect(() => {
    navigator.geolocation.getCurrentPosition(function (position) {
      setState({
        coords: {
          lat: position.coords.latitude,
          lng: position.coords.longitude,
        },
      });
    });
  }, []);

  useEffect(() => {
    handleGetAllJobs(state?.announes);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state?.announes]);
  const handleClearSearchFeilds = () => {
    try {
      setInputValueForOrigin("");
      setInputValueForDestination("");
      setOriginLocationForMap({});
      setDestinationLocationForMap({});
    } catch (error) {}
  };

  const handleGetAllJobs = async (jobType?: string) => {
    try {
      let user = getDataFromLocalStorage("user");

      setState({
        announes: jobType,
      });
      let body: any = {
        type: state?.announes,
        limit: false,
        user: user?.id ?? null,
      };
      if (jobType === "Around Me") {
        body = {
          ...body,
          lat: state?.coords?.lat,
          lng: state?.coords?.lng,
        };
      }
      const resp = await apiServices.postFromApi(
        "c2c-shipments/web-all-announcements",
        body,
        ""
      );

      setState({
        allJobsData: resp?.data,
      });
      // const locations = state?.allJobsData?.pickup?.map(
      //   (item: any) => item.location
      // );
    } catch (error) {
      console.log(error);
    }
  };
  const handleGetJobInfo = async (item?: any) => {
    try {
      let user = getDataFromLocalStorage("user");

      if (!user) {
        setState({ openLoginDialog: true });
        return;
      }
      console.log(item);

      let obj: any = {
        id: Number(item?.id),
        customer_id: Number(user?.id),
      };

      const resp = await apiServices.postFromApi(
        `c2c-shipments/details`,
        obj,
        ""
      );

      handleGetUserDetails(resp?.data);

      const accepter_details = resp?.data?.negotiations?.filter(
        (i: any) => Number(i?.accepter_id) === Number(user?.id)
      );

      accepter_details?.sort((a: any, b: any) =>
        new Date(a?.created_at).getTime() > new Date(b?.created_at).getTime()
          ? -1
          : 1
      );

      if (accepter_details?.[0]?.is_accepted === null) {
        setState({
          disableNegotiate: true,
          accepter_details,
        });
      }

      setState({
        jobDetails: resp?.data,
        image_slider: resp?.data?.shipment_items?.flatMap(
          (item: any) => item?.prod_images || []
        ),
        openJobDialog: true,
        negotiated_price: resp?.data?.ship_price + 1,
      });
    } catch (error) {
      console.log("error", error);
    }
  };

  const handleGetUserDetails = async (item?: any) => {
    try {
      const resp = await apiServices.getFromApi(
        `c2c/get-user-details/${item?.user_details?.id}`,
        ""
      );

      let avg_rating_ = resp.data?.ratings2?.reduce((a: any, b: any) => {
        return a + b.rating;
      }, 0);
      let avg_rating = isNaN(avg_rating_ / resp?.data?.ratings2?.length)
        ? 0
        : avg_rating_ / resp?.data?.ratings2?.length;
      setState({
        allRatings: resp?.data,
        details: {
          ...resp.data,
          avg_rating,
        },
      });
    } catch (error) {}
  };

  const onInputChange = (e: any) => {
    try {
      let { value, name } = e.target;
      value = value.replace(".", ",");

      const re = /^\d*(,\d{0,2})?$/;

      if (value === "") {
        setState({
          [name]: value,
        });
        return;
      }

      if (
        !re.test(value) ||
        value[0] === " " ||
        parseFloat(value) < 0 ||
        value[0] === "."
      ) {
        return;
      }

      if (value.length > 1 && value[0] === "0" && !value.includes(".")) {
        return;
      }

      if (parseFloat(value) > 10000) {
        return;
      }

      setState({
        [name]: value,
      });
    } catch (error) {
      console.error("Error in onInputChange:", error);
    }
  };

  const handleAcceptJob = async () => {
    try {
      let obj = {
        ship_id: Number(state?.jobDetails?.id),
        ship_price: Number(state?.jobDetails?.ship_price),
        is_accepted: true,
      };
      let resp = await apiServices.postFromApi(
        "c2c-shipment-negotiations",
        obj,
        ""
      );

      if (resp?.status === 200 || resp?.status === 201) {
        Toast.showSuccess("annonce acceptée");
        handleSentFirstMessage(state?.jobDetails?.ship_price);
        // navigate(`/chat/${state?.jobDetails?.id}`);
        handleGetAllJobs(state?.announes);
        setState({
          openJobDialog: false,
          acceptWarning: false,
          show_accept_success: true,
        });
      }
    } catch (error) {}
  };

  const handleNegotiate = async (valueOne?: any, valueTwo?: any) => {
    if (state.negotiated_price < 1) {
      Toast.Error("Le montant n’est pas valide");
      return;
    }
    handleSentFirstMessage();
  };

  const handleSentFirstMessage = async (amount?: number) => {
    let user = getDataFromLocalStorage("user");

    try {
      const formattedPrice = String(state?.negotiated_price)
        ?.replaceAll("،", ".")
        ?.replaceAll(".", ".")
        ?.replaceAll(",", ".")
        ?.replaceAll("，", ".");

      if (isNaN(Number(formattedPrice))) {
        alert(
          selector.lang === "fr"
            ? `Veuillez entrer un montant valide.`
            : "Please enter a valid amount"
        );

        setState({ disableNegotiateBtn: false });
        return;
      }

      const name = user?.first_name + user?.surname ? ` ${user?.surname}` : "";
      let first_msg: any = {
        message: ``,
        message_status: "sent",
        order_id: `${state?.jobDetails?.id ?? ""}`,
        is_negotiate: true,
        order_details: state.jobDetails,
        sender_id: `${user?.id}`,
        receiver_id: `${state.jobDetails?.customer_id}`,
        sender_name: name,
        created_at: new Date().toISOString(),
      };
      let new_msg: any = {
        message: `${name} has sent you a message. neg_amt=${
          amount ?? Number(formattedPrice)
        }`,
        message_status: "sent",
        order_id: `${state?.jobDetails?.id ?? ""}`,
        is_negotiate: true,
        order_details: null,
        sender_id: `${user?.id}`,
        receiver_id: `${state.jobDetails?.customer_id}`,
        sender_name: name,
        created_at: new Date().toISOString(),
      };
      if (amount) {
        await addDoc(collection(firestoreDB, `chat_negotiations`), first_msg);
        await addDoc(collection(firestoreDB, `chat_negotiations`), new_msg);
        setState({ disableNegotiateBtn: false });
        return;
      }

      let obj: any = {
        ship_id: Number(
          state.jobDetails?.id
            ? state.jobDetails?.id
            : state?.jobDetails?.id ?? state?.jobDetails?.ship_id
        ),
        ship_price: Number(formattedPrice ?? 0),
      };

      if (state?.jobDetails?.negotiations?.length > 0) {
        obj.parent_id = Number(
          state?.jobDetails?.negotiations?.[
            state?.jobDetails?.negotiations?.length - 1
          ]?.id
        );
      }
      await apiServices.postFromApi(
        "c2c-shipment-negotiations/reject",
        {
          negotiation_id: Number(
            state?.jobDetails?.negotiations?.[
              state?.jobDetails?.negotiations?.length - 1
            ]?.id
          ),
        },
        ""
      );

      const resp = await apiServices.postFromApi(
        "/c2c-shipment-negotiations",
        obj,
        ""
      );

      if (resp.status === 201) {
        Toast.showSuccess(strings.offer_request_sent);
        handleGetAllJobs(state?.announes);
        handleGetJobInfo(state?.jobDetails);
        setState({ respData: resp?.result });
        await addDoc(collection(firestoreDB, `chat_negotiations`), first_msg);
        await addDoc(collection(firestoreDB, `chat_negotiations`), new_msg);

        if (resp.status === 201) {
          // getMessages();
          // setState({
          //   message: "",
          //   temp_document: null,
          //   upload_type: null,
          //   temp_gallery: null,
          // });
          setState({
            messagingScreen: true,
            disableNegotiateBtn: false,
            negotiate: false,
          });
        }
      } else {
        Toast.Error(
          resp.error?.message ??
            resp?.message ??
            resp?.error?.error ??
            "Internal Server Error"
        );
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  const handleCloseLoginPage = () => {
    try {
      setState({ openLoginDialog: false });
    } catch (error) {}
  };

  const handlePlaceSelectedDestination = async (
    place: google.maps.places.PlaceResult | null
  ) => {
    if (place && place.geometry) {
      const latitude = place.geometry.location?.lat() || 0;
      const lngitude = place.geometry.location?.lng() || 0;
      const address = place.formatted_address || "";
      // setSelectedLocation({ lat, lng, address });
      setInputValueForDestination(address);
      const lat = latitude;
      const lng = lngitude;
      let originLoc = { lat, lng };

      setState({
        destinationLocation: `${lat},${lng}`,
        destinatioForMap: originLoc,
      });
    }
  };

  const handlePlaceSelected = async (
    place: google.maps.places.PlaceResult | null
  ) => {
    if (place && place.geometry) {
      const latitude = place.geometry.location?.lat() || 0;
      const lngitude = place.geometry.location?.lng() || 0;
      const address = place.formatted_address || "";
      // setSelectedLocation({ lat, lng, address });
      searchJobByOrignin(place);
      setInputValueForOrigin(address);
      const lat = latitude;
      const lng = lngitude;
      let originLoc = { lat, lng };
      setState({
        originLocation: `${latitude},${lngitude}`,
        originForMap: originLoc,
        origin_city: place?.name,
      });
    }
  };

  useEffect(() => {
    if (inputValueForOrigin === "" && inputValueForDestination === "") {
      setOriginLocationForMap({});
      setDestinationLocationForMap({});
      setInputValueForOrigin("");
      setInputValueForDestination("");
      handleGetAllJobs("All");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inputValueForOrigin, inputValueForDestination]);

  const handleGetDirections = async () => {
    try {
      if (!state?.originLocation) {
        Toast.Error("Veuillez sélectionner un lieu de départ valide");
        return;
      }
      if (!state?.destinationLocation) {
        Toast.Error("Veuillez sélectionner un emplacement final valide");
        return;
      }
      let direction_query = `https://api.mapbox.com/directions/v5/mapbox/driving-traffic/${state.originForMap?.lng}%2C${state.originForMap?.lat}%3B${state.destinatioForMap?.lng}%2C${state.destinatioForMap?.lat}?alternatives=false&annotations=distance%2Cduration%2Cspeed%2Ccongestion%2Cmaxspeed%2Cclosure%2Ccongestion_numeric&banner_instructions=true&geometries=geojson&language=en&overview=full&roundabout_exits=true&steps=true&access_token=pk.eyJ1IjoiZnJhbmtmciIsImEiOiJjbTVhcWl5OW4wZzZvMmpzNm5iYzUwNWF5In0.X7R4cjq4TJb1rF0XXqbTSQ`;

      const line_string = await axios(direction_query);
      const user = getDataFromLocalStorage("user");

      let line_string2: any = JSON.stringify(line_string?.data);
      line_string2 = JSON.parse(line_string2);

      if (line_string2?.routes < 1 || !line_string2?.routes) {
        Toast.Error("Aucun itinéraire possible disponible");
        return;
      }
      let obj = {
        data: {
          lineString: `LINESTRING(${line_string2?.routes?.[0]?.geometry?.coordinates
            ?.map((i: any) => i.reverse())
            ?.map((coord: any) => coord.join(" "))
            .join(", ")})`,
          type: "LineString",
          city: state?.origin_city?.name,
          range: 1000,
          user: user?.id ?? null,
        },
      };
      const resp = await apiServices.postFromApi(
        "c2c-shipments/web-all-locations",
        obj,
        ""
      );

      if (resp?.data?.error) {
        Toast.Error("Veuillez sélectionner un point de début et de fin valide");
        return;
      }
      setState({
        allJobsData: resp?.data,
      });

      // let decoded_data = await getDirections(
      //   state?.originLocation,
      //   state?.destinationLocation
      // );
      setOriginLocationForMap(state?.originForMap);
      setDestinationLocationForMap(state?.destinatioForMap);
      // let resp = null;
      // handleApi();
      // if (decoded_data) {
      //   if (decoded_data?.length > 1) {
      //     let obj = {
      //       data: {
      //         range: 5000,
      //         type: "LineString",
      //         coordinates: decoded_data,
      //       },
      //     };
      //     resp = await apiServices.postFromApi(
      //       "c2c-shipments/web-all-locations",
      //       obj,
      //       ""
      //     );

      //     if (resp?.data?.error) {
      //       Toast.Error("Please Select Valid Start and End Point");
      //       return;
      //     }
      //     setState({ allJobsData: resp?.data });
      //   }
      // }
    } catch (error) {}
  };

  const transSizes = (item: any) => {
    const deliveryType = FrankConstants?.packageSize(selector.lang)?.find(
      (a: any) => a.size === item
    );
    return deliveryType?.size_trans;
  };

  const transDelivery = (item: any) => {
    const deliveryType = FrankConstants?.deliveryTypes(selector.lang)?.find(
      (a: any) => a.key === item
    );
    return deliveryType?.label;
  };
  const transSizesForWeight = (item: any) => {
    const deliveryType = FrankConstants?.packageSize(selector.lang)?.find(
      (a: any) => a.size === item
    );
    return deliveryType?.weight_fr;
  };
  const deliveryTypesDesc = (item: any) => {
    const deliveryType = FrankConstants.deliveryTypes(selector.lang)?.find(
      (a: any) => a.key === item
    );

    return deliveryType?.description;
  };

  const searchJobByOrignin = async (data: any) => {
    try {
      const user = getDataFromLocalStorage("user");

      // return;
      let obj = {
        searched_location: data?.name,
        lat: data?.geometry.location?.lat() || 0,
        lng: data?.geometry.location?.lng() || 0,
        user: user?.id ?? null,
      };
      let resp = await apiServices.postFromApi(
        "/c2c-shipments/search-by-city",
        obj,
        ""
      );
      setState({ allJobsData: resp?.data?.data });
    } catch (error) {}
  };
  const [currentIndex, setCurrentIndex] = useState(0);

  const handleNext = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex < state?.image_slider?.length - 1 ? prevIndex + 1 : prevIndex
    );
  };

  const handlePrevious = () => {
    setCurrentIndex((prevIndex) => (prevIndex > 0 ? prevIndex - 1 : prevIndex));
  };
  return (
    <>
      <Helmet>
        <title>Toutes les Annonces | Livraison Collaborative avec Frank</title>
        <link rel="canonical" href="https://www.frank.fr/announces" />
        <link
          rel="icon"
          type="image/png"
          href="../../../public/frank_favicon.png"
        />
        <meta
          name="description"
          content="Découvrez toutes les annonces de livraison collaborative sur Frank. Trouvez des offres pour envoyer ou transporter des colis facilement et à moindre coût."
        />
      </Helmet>

      <div className="web-screen">
        <div
          style={{
            background: defaultLabelColors.main_background_new,
            justifyItems: "center",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <div
            style={{
              maxWidth: 1408,
              width: "100%",
            }}
          >
            <NewHeader />
            <div style={{ padding: "120px 50px 0px 50px" }}>
              <Grid container spacing={2}>
                <Grid xs={12} md={12} item>
                  <div>
                    <h1
                      className="page-title-one"
                      style={{
                        fontFamily: "montserrat-Bold",
                        fontSize: screen_1024 ? 48 : "28px",
                        color: defaultLabelColors.main_font_brown,
                        marginBottom: "44px",
                      }}
                    >
                      {strings?.announcements}{" "}
                    </h1>
                  </div>
                </Grid>
              </Grid>

              <Grid container spacing={2}>
                <Grid xs={12} md={12} item>
                  <div>
                    <p
                      style={{
                        fontFamily: "montserrat-Bold",
                        fontSize: "20px",
                        color: "#000",
                        marginTop: 0,
                      }}
                    >
                      Votre trajet
                    </p>
                    <div
                      style={{
                        position: "relative",
                        display: "flex",
                        width: "100%",
                        gap: !screen_1024 ? "8px" : "20px",
                        justifyContent: "center",
                        alignItems: !screen_1024 ? "" : "center",
                        flexDirection: !screen_1024 ? "column" : "row",
                      }}
                    >
                      {!screen_1024 ? (
                        <div id="main_pa" style={{ display: "flex", gap: 10 }}>
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              width: "40px",
                              padding: "10px 0px",
                            }}
                          >
                            <div>
                              {" "}
                              <HomeIcon
                                height={36}
                                width={36}
                                fillOpacity={"50%"}
                              />
                            </div>
                            <div
                              style={{
                                width: "2px",
                                height: "40px",
                                borderLeft: "2px dashed #BCBBC4",
                                margin: "auto",
                              }}
                            ></div>
                            <div>
                              {" "}
                              <PointerIcon
                                height={36}
                                width={36}
                                fillOpacity={"50%"}
                              />
                            </div>
                          </div>
                          <div
                            id="address_field"
                            style={{
                              width: "100%",
                              display: "flex",
                              flexDirection: "column",
                              gap: 10,
                            }}
                          >
                            <div style={{ width: "100%" }}>
                              <GoogleAutocompleteField
                                apiKey={apiKey}
                                placeholder="Lieu de départ"
                                inputValue={inputValueForOrigin}
                                onInputChange={setInputValueForOrigin}
                                onPlaceSelected={handlePlaceSelected}
                                key={"selectedLocation"}
                                styles={{
                                  background: "#fff",
                                  width: "100%",
                                  borderRadius: "12px",
                                  border: "none",
                                  fontSize: "16px",
                                  marginTop: "10px",
                                  fontFamily: "montserrat-Regular",
                                  padding: "10px",
                                  margin: "0px !important",
                                  zIndex: 1111,
                                  color: "#1E1D3A",
                                  height: "41px",
                                }}
                              />
                            </div>

                            <div style={{ width: "100%" }}>
                              <GoogleAutocompleteField
                                apiKey={apiKey}
                                placeholder="Lieu d’arrivée"
                                inputValue={inputValueForDestination}
                                onInputChange={setInputValueForDestination}
                                onPlaceSelected={handlePlaceSelectedDestination}
                                key={"selectedLocation"}
                                styles={{
                                  background: "#fff",
                                  width: "100%",
                                  borderRadius: "12px",
                                  border: "none",
                                  fontSize: "16px",
                                  // margin: "10px",
                                  fontFamily: "montserrat-Regular",
                                  padding: "10px",
                                  // marginLeft: 9,
                                  zIndex: 1111,
                                  color: "#1E1D3A",
                                  height: "41px",
                                }}
                              />
                            </div>
                          </div>
                        </div>
                      ) : (
                        <>
                          <div style={{ width: "100%" }}>
                            <GoogleAutocompleteField
                              apiKey={apiKey}
                              placeholder="Lieu de départ"
                              inputValue={inputValueForOrigin}
                              onInputChange={setInputValueForOrigin}
                              onPlaceSelected={handlePlaceSelected}
                              key={"selectedLocation"}
                              styles={{
                                background: "#fff",
                                width: "90%",
                                borderRadius: "12px",
                                border: "none",
                                fontSize: "16px",
                                marginTop: "10px",
                                fontFamily: "montserrat-Regular",
                                padding: "10px",
                                margin: "0px !important",
                                zIndex: 1111,
                                color: "#1E1D3A",
                                height: "41px",
                              }}
                            />
                          </div>
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              justifyContent: "center",
                              alignItems: "center",
                              gap: 5,
                              marginLeft: -20,
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                paddingTop: "10px",
                              }}
                            >
                              <div>
                                <HomeIcon
                                  height={36}
                                  width={36}
                                  fillOpacity={"50%"}
                                />
                              </div>
                              <div
                                style={{
                                  height: "1px",
                                  borderTop: "1px dashed grey",
                                  width: "80px",
                                  margin: "0px 5px",
                                }}
                              ></div>
                              <div>
                                <PointerIcon
                                  height={36}
                                  width={36}
                                  fillOpacity={"50%"}
                                />
                              </div>
                            </div>
                          </div>

                          <div style={{ width: "100%" }}>
                            <GoogleAutocompleteField
                              apiKey={apiKey}
                              placeholder="Lieu d’arrivée"
                              inputValue={inputValueForDestination}
                              onInputChange={setInputValueForDestination}
                              onPlaceSelected={handlePlaceSelectedDestination}
                              key={"selectedLocation"}
                              styles={{
                                background: "#fff",
                                width: "90%",
                                borderRadius: "12px",
                                border: "none",
                                fontSize: "16px",
                                margin: "10px",
                                fontFamily: "montserrat-Regular",
                                padding: "10px",
                                // marginLeft: 9,
                                zIndex: 1111,
                                color: "#1E1D3A",
                                height: "41px",
                              }}
                            />
                          </div>
                        </>
                      )}
                      <CustomButton
                        style={{
                          fontSize: "16px",
                          fontWeight: "500",
                          color: "#fff",
                          fontFamily: "montserrat-Regular",
                          background:
                            inputValueForOrigin && inputValueForDestination
                              ? "#ee6931"
                              : "lightgrey",
                          border: "none",
                          borderRadius: "12px",
                          padding: !screen_1024 ? "12px 24px" : "15px 70px",
                          height: "100%",
                          minHeight: "55px",
                          width: "174px",
                          "&:hover": {
                            background:
                              inputValueForOrigin && inputValueForDestination
                                ? "#d85c26"
                                : "lightgrey",
                          },
                        }}
                        disable={
                          inputValueForOrigin && inputValueForDestination
                            ? false
                            : true
                        }
                        value={strings?.search}
                        onClick={handleGetDirections}
                      />{" "}
                    </div>
                  </div>
                </Grid>
              </Grid>

              <Grid
                container
                spacing={2}
                style={{ paddingTop: !screen_1024 ? "16px" : "40px" }}
              >
                <Grid
                  xs={screen_1024 ? 6 : 12}
                  item
                  style={{
                    fontSize: "20px",
                    fontFamily: "montserrat-Bold",
                    color: "#000",
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "flex-end",
                  }}
                >
                  <p style={{ margin: 0 }}>Annonces sur le trajet</p>
                  <p style={{ margin: 0 }}>
                    <div
                      style={{
                        fontSize: "16px",
                        fontFamily: "montserrat-SemiBold",
                        color: defaultLabelColors.main_font_brown,
                      }}
                    >
                      {state?.allJobsData?.length ?? ""} annonces en lignes
                    </div>
                  </p>
                </Grid>

                <Grid
                  xs={screen_1024 ? 6 : 12}
                  item
                  style={{
                    display: "flex",
                    justifyContent: screen_1024 ? "flex-end" : "flex-start",
                    alignItems: "center",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      gap: 10,
                      justifyContent: "flex-end",
                    }}
                  >
                    <CustomButton
                      value={"Tout"}
                      classesNames={
                        state?.announes === "All"
                          ? "contained_button_for_transporter"
                          : "outlined_button_for_annoucement"
                      }
                      onClick={() => {
                        setState({ announes: "All" });
                        handleClearSearchFeilds();
                      }}
                    />
                    <CustomButton
                      value={"Urgent"}
                      classesNames={
                        state?.announes === "Urgent"
                          ? "contained_button_for_transporter"
                          : "outlined_button_for_annoucement"
                      }
                      onClick={() => {
                        setState({ announes: "Urgent" });
                        handleClearSearchFeilds();
                      }}
                    />
                    <CustomButton
                      value={"Autour de moi"}
                      classesNames={
                        state?.announes === "Around Me"
                          ? "contained_button_for_transporter"
                          : "outlined_button_for_annoucement"
                      }
                      onClick={() => {
                        setState({ announes: "Around Me" });
                        handleClearSearchFeilds();
                      }}
                    />
                  </div>
                </Grid>
              </Grid>

              <Grid
                container
                spacing={2}
                style={{ marginTop: "0px", paddingBottom: "20px" }}
              >
                {state?.allJobsData?.length < 1 ? (
                  <div
                    style={{
                      width: "100%",
                      fontSize: "32px",
                      fontWeight: "700",
                      textAlign: "center",
                      fontFamily: "montserrat-Regular",
                      marginTop: "20px",
                    }}
                  >
                    <p>Aucune annonce trouvée</p>
                    {/* <img
                    src={noJobsImage}
                    alt="not-found"
                    style={{ opacity: "0.5" }}
                  /> */}
                    <NoAnnoucementImage width={"100%"} height={"50vh"} />
                  </div>
                ) : (
                  state?.allJobsData?.map((i: any) => {
                    return (
                      <Grid xs={12} md={6} lg={6} xl={6} sm={6} item>
                        <span onClick={() => handleGetJobInfo(i)}>
                          <AnnoucementCard i={i} />
                        </span>
                      </Grid>
                    );
                  })
                )}
              </Grid>
            </div>
          </div>
        </div>
        <div style={{ background: "#FFF8F5" }}>
          {screen_1024 ? (
            <div
              className="main-container"
              style={{ background: defaultLabelColors.main_background_new }}
            >
              <CustomFooter />
            </div>
          ) : screen_600 ? (
            <CustomMobileFooter />
          ) : null}
        </div>

        <DraggableDialog
          open={state?.openJobDialog}
          maxWidth={"md"}
          Width={"755px"}
          draggable={true}
          handleClose={() => {
            setState({
              openJobDialog: false,
              messagingScreen: false,
              negotiate: false,
              disableNegotiate: false,
              accepter_details: [],
              negotiated_price: "",
              initilalTotalFeedBack: 3,
              showReviews: false,
            });
          }}
          // handleClose={(event,reason)=>{

          // }}
          dialog_title={
            state?.showReviews ? (
              ""
            ) : (
              <>
                {state?.jobDetails?.shipment_items?.length > 1 ? (
                  <div>
                    <h3
                      style={{
                        color: "#080626",
                        fontFamily: "montserrat-Bold",
                        fontSize: 18,
                        marginLeft: 1,
                        display: "-webkit-box",
                        WebkitLineClamp: 1, // Ensures the text is limited to one line
                        lineClamp: 1, // Fallback for browsers that support it
                        WebkitBoxOrient: "vertical",
                        maxWidth: "100%",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        margin: 0,
                      }}
                    >
                      {state?.jobDetails?.shipment_items?.length ?? 1} articles
                      :
                      <span
                        style={{
                          color: "#78778A",
                          fontFamily: "montserrat-Regular",
                          fontSize: 12,
                          marginLeft: 1,
                        }}
                      >
                        {" "}
                        {state?.jobDetails?.shipment_items
                          ?.map((item: any) => item.item_name_fr)
                          .join(", ")}
                      </span>
                    </h3>
                  </div>
                ) : (
                  <h3
                    style={{
                      color: "#080626",
                      fontFamily: "montserrat-Bold",
                      fontSize: 18,
                      margin: 0,
                    }}
                  >
                    {handleLocalize({
                      en: state?.jobDetails?.shipment_items?.[0]?.item_name_en
                        ?.en,
                      fr: state?.jobDetails?.shipment_items?.[0]?.item_name_fr
                        ?.en,
                    }) ??
                      state?.jobDetails?.shipment_items?.[0]?.prod_name ??
                      ""}
                  </h3>
                )}
              </>
            )
          }
          classes={classes}
          dialogBody={
            <DialogContent style={{}} dividers>
              {state?.showReviews ? (
                <>
                  <div
                    style={{
                      fontFamily: "montserrat-Bold",
                      color: "#000",
                      display: "flex",
                      alignItems: "center",
                      gap: 10,
                    }}
                    onClick={() => {
                      setState({ showReviews: false });
                    }}
                  >
                    <ArrowBack style={{ cursor: "pointer" }} />
                    Avis
                  </div>

                  <div>
                    <span
                      style={{
                        fontSize: "64px",
                        fontFamily: "montserrat-Bold",
                        width: "100%",
                        color: "#281208",
                        marginTop: "10px",
                        display: "flex",
                        alignItems: "center",
                        gap: 7,
                      }}
                    >
                      {` ${
                        numberFormatWithoutCurrencyFixedOne(
                          state?.jobDetails?.user_details?.cus_ratings?.toFixed(
                            1
                          )
                        ) ?? "0"
                      } `}
                      <svg
                        width="20"
                        height="21"
                        viewBox="0 0 20 21"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M9.60428 2.41176C9.6408 2.33798 9.69722 2.27587 9.76716 2.23245C9.8371 2.18903 9.91779 2.16602 10.0001 2.16602C10.0824 2.16602 10.1631 2.18903 10.2331 2.23245C10.303 2.27587 10.3594 2.33798 10.396 2.41176L12.3209 6.31093C12.4478 6.56757 12.635 6.7896 12.8665 6.95797C13.098 7.12634 13.3669 7.23602 13.6501 7.27759L17.9551 7.90759C18.0367 7.91941 18.1133 7.95382 18.1764 8.00693C18.2394 8.06003 18.2863 8.12972 18.3118 8.2081C18.3373 8.28648 18.3403 8.37043 18.3206 8.45046C18.3009 8.53048 18.2591 8.60339 18.2001 8.66093L15.0868 11.6926C14.8815 11.8927 14.7278 12.1397 14.6391 12.4123C14.5504 12.6849 14.5293 12.975 14.5776 13.2576L15.3126 17.5409C15.327 17.6225 15.3182 17.7064 15.2872 17.7832C15.2562 17.8599 15.2042 17.9264 15.1372 17.9751C15.0702 18.0237 14.9909 18.0526 14.9083 18.0583C14.8257 18.0641 14.7432 18.0465 14.6701 18.0076L10.8218 15.9843C10.5682 15.8511 10.2861 15.7816 9.9997 15.7816C9.7133 15.7816 9.43119 15.8511 9.17762 15.9843L5.33012 18.0076C5.25706 18.0463 5.17461 18.0637 5.09216 18.0578C5.0097 18.0519 4.93055 18.0231 4.8637 17.9744C4.79684 17.9258 4.74498 17.8594 4.714 17.7828C4.68302 17.7061 4.67416 17.6223 4.68845 17.5409L5.42262 13.2584C5.47111 12.9757 5.4501 12.6854 5.3614 12.4126C5.27269 12.1398 5.11896 11.8927 4.91345 11.6926L1.80012 8.66176C1.74061 8.60429 1.69844 8.53126 1.67842 8.45099C1.65839 8.37072 1.66131 8.28644 1.68685 8.20775C1.71238 8.12906 1.75951 8.05913 1.82285 8.00591C1.88619 7.9527 1.9632 7.91834 2.04512 7.90676L6.34928 7.27759C6.63283 7.23634 6.90211 7.12681 7.13394 6.95842C7.36577 6.79002 7.5532 6.56782 7.68012 6.31093L9.60428 2.41176Z"
                          fill="black"
                          stroke="black"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </svg>
                    </span>
                    <p
                      style={{
                        fontFamily: "montserrat-Regular",
                        color: defaultLabelColors.main_font_grey,
                        fontSize: "16px",
                      }}
                    >
                      {state?.allRatings?.ratings2?.length ?? "0"} Avis
                    </p>
                  </div>

                  {state?.allRatings?.ratings2?.map((i: any) => {
                    return (
                      <div style={{ borderTop: "1px solid #E9E8EB" }}>
                        <p>
                          <Rating
                            size={15}
                            initialValue={i?.rating ?? 0}
                            fillIcon={<SmallStarIcon />}
                            emptyIcon={<SmallStarIconGray />}
                            readonly
                          />
                        </p>
                        <p
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: 10,
                          }}
                        >
                          <Box
                            sx={{
                              position: "relative",
                              width: 60,
                              height: 60,
                              borderRadius: "50%",
                              overflow: "hidden",
                              justifyContent: "center",
                              alignItems: "center",
                              boxShadow: 3,
                              border: "1px solid #E0E0E0",
                            }}
                          >
                            <img
                              src={i?.profile_pic ?? no_profile_image}
                              alt="Profile"
                              onError={(e) => {
                                e.currentTarget.onerror = null; // Prevent infinite loop
                                e.currentTarget.src = no_profile_image;
                              }}
                              style={{
                                width: "100%",
                                height: "100%",
                                objectFit: "cover",
                              }}
                            />
                          </Box>
                          <span
                            style={{
                              lineHeight: 1.5,
                              fontFamily: "montserrat-Regular",
                              color: "#BCBBC4",
                              fontSize: 16,
                            }}
                          >
                            {i?.added_by}
                            <br />

                            {moment(i?.created_at).format("MMM YYYY")}
                          </span>
                        </p>
                        <p
                          style={{
                            fontFamily: "montserrat-Regular",
                            color: defaultLabelColors.main_font,
                            fontSize: 16,
                          }}
                        >
                          {i?.feedback ? `“${i?.feedback}` : ""}
                        </p>
                      </div>
                    );
                  })}
                </>
              ) : (
                <>
                  <div
                    style={{
                      background: defaultLabelColors.white,
                      borderRadius: 24,
                    }}
                  >
                    <div style={{ display: "flex", gap: 5 }}>
                      <div style={{ flex: 1, width: "20%" }}>
                        <p
                          style={{
                            margin: 0,
                            fontSize: 12,
                            color: "#78778A",
                            fontFamily: "montserrat-Regular",
                          }}
                        >
                          {moment(state?.jobDetails?.created_at).format(
                            "[Publié le] DD/MM/YYYY [à] HH[h]mm"
                          )}
                        </p>
                      </div>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        marginTop: 8,
                        gap: 10,
                        maxHeight: 181,
                      }}
                    >
                      <div
                        style={{
                          flex: 1,
                          width: "30%",
                          position: "relative",
                          display: "flex",
                          justifyContent: "flex-end",
                          alignItems: "center",
                        }}
                      >
                        <img
                          alt="product-img"
                          src={
                            state?.jobDetails?.shipment_items?.[0]
                              ?.prod_images?.[0] ?? noImageTwo
                          }
                          onError={(e) => {
                            e.currentTarget.onerror = null; // Prevent infinite loop
                            e.currentTarget.src = noImageTwo;
                          }}
                          style={{
                            objectFit: "cover",
                            borderRadius: 16,
                            height: "182px",
                            width: "192px",
                          }}
                        />
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            position: "absolute",
                            // top: "50%",
                            right: 0,
                          }}
                        >
                          <IconButton
                            onClick={() => {
                              setState({ image_box: true });
                            }}
                            // disabled={
                            //   startIndex + itemsPerPage >= reviews?.length
                            // }
                          >
                            <svg
                              width="19"
                              height="20"
                              viewBox="0 0 19 20"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <rect
                                x="0.03125"
                                width="18.9375"
                                height="19.2381"
                                rx="9.46875"
                                fill="white"
                              />
                              <path
                                d="M7.84668 12.9256L11.1532 9.61905L7.84668 6.3125"
                                stroke="black"
                                stroke-width="1.32262"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                            </svg>
                          </IconButton>
                        </div>
                      </div>
                      <div
                        style={{
                          borderRadius: 16,
                          background: "#F4F3F6",
                          padding: "16px",
                          display: "flex",
                          flexDirection: "column",
                          gap: "8px",
                          width: "70%",
                          maxWidth: "80%",
                        }}
                      >
                        {/* Pickup Address */}
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "12px",
                          }}
                        >
                          <div
                            style={{
                              width: "40px",
                              height: "40px",
                              borderRadius: "50%",
                              background: "#FFFFFF",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              // boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
                            }}
                          >
                            <HomeIcon height={30} color="#3026F1" />
                          </div>
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              gap: 10,
                            }}
                          >
                            <span
                              style={{
                                fontFamily: "montserrat-Regular",
                                fontSize: "14px",
                                color: "#626175",
                              }}
                            >
                              Adresse de ramassage
                            </span>
                            <Tooltip
                              title={`${
                                state?.jobDetails?.pickup?.city ?? "City"
                              }, ${
                                state?.jobDetails?.pickup?.country ?? "Country"
                              }
                              ${
                                state?.jobDetails?.pickup?.digital_code
                                  ? `(${state?.jobDetails?.pickup?.digital_code})`
                                  : ""
                              }
                              `}
                            >
                              <span
                                style={{
                                  fontFamily: "montserrat-SemiBold",
                                  fontSize: "16px",
                                  whiteSpace: "nowrap",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  maxWidth: "220px",
                                  color: "#000",
                                }}
                              >
                                {`${
                                  state?.jobDetails?.pickup?.city ?? "City"
                                }, ${
                                  state?.jobDetails?.pickup?.country ??
                                  "Country"
                                } 
                              ${
                                state?.jobDetails?.pickup?.digital_code
                                  ? `(${state?.jobDetails?.pickup?.digital_code})`
                                  : ""
                              }
                              `}
                              </span>
                            </Tooltip>
                          </div>
                        </div>

                        {/* Dashed Line */}
                        <div
                          style={{
                            width: "2px",
                            height: "30px",
                            borderLeft: "2px dashed #A0A0A0",
                            marginLeft: "21px",
                          }}
                        />

                        {/* Dropoff Address */}
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "12px",
                          }}
                        >
                          <div
                            style={{
                              width: "40px",
                              height: "40px",
                              borderRadius: "50%",
                              background: "#FFFFFF",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              // boxShadow: "0px 2px 4px rgba(0, 0, 0, 0.1)",
                            }}
                          >
                            <PointerIcon height={30} color="#F15A24" />
                          </div>
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              gap: 10,
                            }}
                          >
                            <span
                              style={{
                                fontFamily: "montserrat-Regular",
                                fontSize: "14px",
                                color: "#626175",
                              }}
                            >
                              Adresse de livraison
                            </span>
                            <Tooltip
                              title={`${
                                state?.jobDetails?.dropoff?.city ?? "City"
                              }, ${
                                state?.jobDetails?.dropoff?.country ?? "Country"
                              }  ${
                                state?.jobDetails?.dropoff?.digital_code
                                  ? `(${state?.jobDetails?.dropoff?.digital_code})`
                                  : ""
                              }
                              
                              

                              `}
                            >
                              <span
                                style={{
                                  fontFamily: "montserrat-SemiBold",
                                  fontSize: "16px",
                                  whiteSpace: "nowrap",
                                  overflow: "hidden",
                                  textOverflow: "ellipsis",
                                  maxWidth: "220px",
                                  color: "#000",
                                }}
                              >
                                {`${
                                  state?.jobDetails?.dropoff?.city ?? "City"
                                }, ${
                                  state?.jobDetails?.dropoff?.country ??
                                  "Country"
                                }  ${
                                  state?.jobDetails?.dropoff?.digital_code
                                    ? `(${state?.jobDetails?.dropoff?.digital_code})`
                                    : ""
                                }
                              
                              

                              `}
                              </span>
                            </Tooltip>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    style={{
                      borderBottom: "1px solid #E0E0E0",
                      padding: "16px 16px",
                      display: "flex",
                      flexDirection: "column",
                      gap: "8px",
                    }}
                  >
                    <div style={{ display: "flex" }}>
                      <div
                        style={{
                          flex: 1,
                          fontFamily: "montserrat-Regular",
                          fontSize: "14px",
                          color: "#080626",
                        }}
                      >
                        Détail de l’expéditeur
                      </div>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "flex-end",
                          alignItems: "flex-end",
                          fontFamily: "montserrat-Regular",
                          fontSize: "12px",
                          color: "#78778A",
                        }}
                      >
                        Membre depuis &nbsp;
                        <span>
                          {moment(
                            state?.jobDetails?.user_details?.created_at
                          ).format("YYYY") ?? "recently"}
                        </span>
                      </div>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        cursor: "pointer",
                        gap: "32px",
                      }}
                      onClick={() => {
                        setState({ showReviews: true });
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "flex-start",
                          alignItems: "center",
                        }}
                      >
                        <Box
                          sx={{
                            position: "relative",
                            display: "flex",
                            //  border: `1px solid ${color_theme.black_10}`,
                            borderRadius: "100%",
                            height: 60,
                            width: 60,
                          }}
                        >
                          <img
                            src={
                              state?.jobDetails?.user_details?.profile_pic ??
                              no_profile_image
                            }
                            alt="Profile"
                            onError={(e) => {
                              e.currentTarget.onerror = null; // Prevent infinite loop
                              e.currentTarget.src = no_profile_image;
                            }}
                            style={{
                              width: "100%",
                              height: "100%",
                              objectFit: "cover",
                              borderRadius: "100%",
                            }}
                          />
                          {state?.details?.idenfy_verification === true &&
                          state?.details?.idenfy_verification_status ===
                            "APPROVED" ? (
                            <div
                              style={{
                                position: "absolute",
                                bottom: "-4px",
                                right: 0,
                              }}
                            >
                              <VerifyIcon />
                            </div>
                          ) : null}
                        </Box>
                      </div>
                      <div
                        style={{
                          // flex: 1,/
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          // paddingLeft: 10,
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                          }}
                        >
                          <p
                            style={{
                              fontFamily: "montserrat-Bold",
                              fontSize: "18px",
                              margin: 0,
                              color: "#080626",
                            }}
                          >
                            {state?.jobDetails?.user_details?.cus_name ??
                              "Customer Name"}
                          </p>

                          <span
                            style={{
                              fontSize: "22px",
                              fontFamily: "montserrat-Bold",
                              width: "100%",
                              color: "#281208",
                              // marginTop: "10px",
                              display: "flex",
                              alignItems: "center",
                              gap: 7,
                            }}
                          >
                            {` ${
                              currencyFormat(
                                state?.jobDetails?.user_details?.cus_ratings?.toFixed(
                                  1
                                )
                              ) ?? "0"
                            } `}
                            <svg
                              width="20"
                              height="21"
                              viewBox="0 0 20 21"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                d="M9.60428 2.41176C9.6408 2.33798 9.69722 2.27587 9.76716 2.23245C9.8371 2.18903 9.91779 2.16602 10.0001 2.16602C10.0824 2.16602 10.1631 2.18903 10.2331 2.23245C10.303 2.27587 10.3594 2.33798 10.396 2.41176L12.3209 6.31093C12.4478 6.56757 12.635 6.7896 12.8665 6.95797C13.098 7.12634 13.3669 7.23602 13.6501 7.27759L17.9551 7.90759C18.0367 7.91941 18.1133 7.95382 18.1764 8.00693C18.2394 8.06003 18.2863 8.12972 18.3118 8.2081C18.3373 8.28648 18.3403 8.37043 18.3206 8.45046C18.3009 8.53048 18.2591 8.60339 18.2001 8.66093L15.0868 11.6926C14.8815 11.8927 14.7278 12.1397 14.6391 12.4123C14.5504 12.6849 14.5293 12.975 14.5776 13.2576L15.3126 17.5409C15.327 17.6225 15.3182 17.7064 15.2872 17.7832C15.2562 17.8599 15.2042 17.9264 15.1372 17.9751C15.0702 18.0237 14.9909 18.0526 14.9083 18.0583C14.8257 18.0641 14.7432 18.0465 14.6701 18.0076L10.8218 15.9843C10.5682 15.8511 10.2861 15.7816 9.9997 15.7816C9.7133 15.7816 9.43119 15.8511 9.17762 15.9843L5.33012 18.0076C5.25706 18.0463 5.17461 18.0637 5.09216 18.0578C5.0097 18.0519 4.93055 18.0231 4.8637 17.9744C4.79684 17.9258 4.74498 17.8594 4.714 17.7828C4.68302 17.7061 4.67416 17.6223 4.68845 17.5409L5.42262 13.2584C5.47111 12.9757 5.4501 12.6854 5.3614 12.4126C5.27269 12.1398 5.11896 11.8927 4.91345 11.6926L1.80012 8.66176C1.74061 8.60429 1.69844 8.53126 1.67842 8.45099C1.65839 8.37072 1.66131 8.28644 1.68685 8.20775C1.71238 8.12906 1.75951 8.05913 1.82285 8.00591C1.88619 7.9527 1.9632 7.91834 2.04512 7.90676L6.34928 7.27759C6.63283 7.23634 6.90211 7.12681 7.13394 6.95842C7.36577 6.79002 7.5532 6.56782 7.68012 6.31093L9.60428 2.41176Z"
                                fill="black"
                                stroke="black"
                                stroke-width="2"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                              />
                            </svg>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div
                    style={{
                      padding: 20,
                      display: "flex",
                      alignItems: "center",
                      borderBottom: state?.negotiate
                        ? "none"
                        : "1px solid #E0E0E0",
                    }}
                  >
                    <div
                      style={{
                        fontFamily: "montserrat-Bold",
                        fontSize: 18,
                        color: defaultLabelColors.main_font,
                        flex: 1,
                      }}
                    >
                      Proposition{" "}
                      <span
                        style={{
                          color: defaultLabelColors.main_orange_new,
                          paddingLeft: 15,
                        }}
                      >
                        {" "}
                        {currencyFormat(
                          state?.jobDetails?.ship_price?.toFixed(2)
                        )}{" "}
                        €{" "}
                      </span>
                    </div>

                    <div
                      style={{
                        display: "flex",
                        gap: "10px",
                      }}
                    >
                      <CustomButton
                        classesNames={
                          state?.disableNegotiate
                            ? "disable_outline_button_for_nego"
                            : "outline_button_for_nego"
                        }
                        value={strings?.negotiate}
                        disable={state?.disableNegotiate}
                        style={{
                          cursor: state?.disableNegotiate ? "auto" : "pointer",
                          minWidth: "145px",
                        }}
                        onClick={() => {
                          if (state?.disableNegotiate) return;
                          setState({ negotiate: true });
                        }}
                      />
                      <CustomButton
                        classesNames={
                          state?.negotiate || state?.disableNegotiate
                            ? "disable_contained_button_for_nego"
                            : "contained_button_for_nego"
                        }
                        value={strings?.accept}
                        disable={
                          state?.negotiate || state?.disableNegotiate
                            ? true
                            : false
                        }
                        style={{
                          minWidth: "145px",
                        }}
                        // onClick={handleAcceptJob}
                        onClick={() => {
                          setState({ acceptWarning: true });
                        }}
                      />
                    </div>
                  </div>

                  {state?.negotiate ? (
                    <div
                      style={{
                        borderBottom: "1px solid #E0E0E0",
                      }}
                    >
                      <div style={{ display: "flex", flexDirection: "column" }}>
                        <p
                          style={{
                            fontFamily: "montserrat-SemiBold",
                            fontSize: 16,
                            color: "#281208",
                            margin: 0,
                            paddingLeft: 10,
                          }}
                        >
                          Insérez le montant de votre offre
                        </p>
                        <div>
                          <InputField
                            placeHolder={"ex: 9€"}
                            onchange={onInputChange}
                            input_value={state?.negotiated_price}
                            input_name={"negotiated_price"}
                            input_style={{
                              background: "#F4F3F6",
                              width: "99%",
                              borderRadius: 12,
                            }}
                          />
                        </div>
                      </div>
                      <div style={{ marginLeft: "10px", marginBottom: "10px" }}>
                        <CustomButton
                          classesNames={"outline_button_for_nego"}
                          value={"Annuler"}
                          onClick={() => {
                            setState({ negotiate: false });
                          }}
                          style={{ minWidth: "145px" }}
                        />
                        <CustomButton
                          classesNames={"contained_button_for_nego"}
                          value={"Valider"}
                          style={{ marginLeft: 10, minWidth: "145px" }}
                          onClick={() => {
                            // if (state?.disableNegotiateBtn) return;

                            setState({
                              disableNegotiateBtn: true,
                            });
                            setTimeout(() => {
                              handleNegotiate(
                                state.negotiated_price,
                                state?.jobDetails?.id
                              );
                            }, 500);
                          }}
                        />
                      </div>
                    </div>
                  ) : null}

                  {state?.disableNegotiate && (
                    <div
                      style={{
                        borderBottom: "1px solid #E0E0E0",
                        paddingBottom: 15,
                      }}
                    >
                      <div
                        style={{
                          padding: "16px",
                          display: "flex",
                          background: "#F4F3F6",
                          borderRadius: 10,
                          marginTop: 10,
                        }}
                      >
                        <div
                          style={{
                            fontFamily: "montserrat-SemiBold",
                            fontSize: "16px",
                            flex: 1,
                          }}
                        >
                          Vous avez fait une offre pour une montant de :{" "}
                          {currencyFormat(
                            state?.accepter_details?.[0]?.ship_price
                          )}{" "}
                          €
                        </div>
                        <div
                          style={{
                            fontFamily: "montserrat-Regular",
                            color: "#4B4A61",
                            fontSize: 14,
                            wordSpacing: "1px",
                          }}
                        >
                          {moment(
                            state?.accepter_details?.[0]?.created_at
                          ).format("DD MMM YYYY - HH:MM")}
                        </div>
                      </div>

                      <div style={{ marginTop: 10 }}>
                        {" "}
                        <CustomButton
                          classesNames={"contained_button_for_nego"}
                          value={" Accéder à la messagerie"}
                          onClick={() => {
                            // setState({ acceptWarning: true });
                            navigate(`/chat/1/${state?.jobDetails?.id}`);
                          }}
                        />
                      </div>

                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          width: "100%",
                        }}
                      ></div>
                    </div>
                  )}

                  <div
                    style={{
                      borderBottom: "1px solid #E0E0E0",
                      padding: "0px 20px 20px 20px",
                      gap: 10,
                      marginTop: "10px",
                    }}
                  >
                    <p
                      style={{
                        fontFamily: "montserrat-Regular",
                        fontSize: "14px",
                        color: defaultLabelColors.main_font,
                      }}
                    >
                      Type de livraison
                    </p>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <p
                        style={{
                          fontFamily: "montserrat-Bold",
                          fontSize: "16px",
                          margin: 0,
                          color: defaultLabelColors.main_font,
                        }}
                      >
                        {transDelivery(state?.jobDetails?.ship_delivery_type) ??
                          "Express"}
                        {" · "}
                        <span
                          style={{
                            color: defaultLabelColors.main_font,
                            fontFamily: "montserrat-Regular",
                          }}
                        >
                          {deliveryTypesDesc(
                            state?.jobDetails?.ship_delivery_type ?? ""
                          )}
                        </span>
                      </p>
                      <p
                        style={{
                          fontFamily: "montserrat-Regular",
                          fontSize: 14,
                          color: "#626175",
                          margin: 0,
                        }}
                      >
                        Annonce créée le{" "}
                        {moment(state?.jobDetails?.created_at).format(
                          "DD/MM/YYYY"
                        )}
                      </p>
                    </div>
                  </div>

                  <div
                    style={{
                      borderBottom: "1px solid #E0E0E0",
                      padding: "16px 20px",
                      gap: 20,
                      marginTop: "10px",
                    }}
                  >
                    {state?.jobDetails?.shipment_items?.length > 1 ? (
                      <>
                        {state?.jobDetails?.shipment_items?.map((i: any) => (
                          <Accordion
                            elevation={0}
                            sx={{
                              border: "none",
                              background: "#FFFF",
                              margin: 0,
                              "&::before": { display: "none", padding: 0 },
                            }}
                            // expanded={state?.expanded_2}
                            // onChange={() => handleExpanded("expanded_2")}
                          >
                            <AccordionSummary
                              style={{ border: "none", padding: 0 }}
                              // expandIcon={<AddIcon />}
                              expandIcon={<ExpandedIcon />} // Dynamic icon change
                              // className="faq-comments"
                              sx={{
                                "&.Mui-expanded h3": {
                                  color: defaultLabelColors?.main_orange_new,
                                }, // Change h3 color when expanded
                              }}
                            >
                              <h3
                                style={{
                                  fontFamily: "montserrat-Bold",
                                  color: "#080626",
                                  fontSize: 18,
                                  margin: 0,
                                  // padding: "20px 0px",
                                }}
                              >
                                {handleLocalize({
                                  en: i?.item_name_en,
                                  fr: i?.item_name_fr,
                                })}
                              </h3>
                            </AccordionSummary>
                            <AccordionDetails style={{ padding: 0 }}>
                              {" "}
                              <p
                                style={{
                                  fontFamily: "montserrat-Regular",
                                  fontSize: "14px",
                                  color: "#4B4A61",
                                }}
                              >
                                {strings?.item_sizes}
                              </p>
                              <div>
                                <p
                                  style={{
                                    fontFamily: "montserrat-Bold",
                                    fontSize: 16,
                                    color: defaultLabelColors.main_font,
                                    margin: 0,
                                  }}
                                >
                                  {transSizes(i?.cat_name ?? "")}
                                  {state?.jobDetails?.prod_quantity > 1
                                    ? "s"
                                    : null}{" "}
                                  · &nbsp;
                                  <span
                                    style={{
                                      fontFamily: "montserrat-Regular",
                                      color: "#626175",
                                    }}
                                  >
                                    {transSizesForWeight(i?.cat_name)}
                                  </span>
                                </p>
                                <p
                                  style={{
                                    fontFamily: "montserrat-Bold",
                                    fontSize: 16,
                                    color: defaultLabelColors.main_font,
                                    margin: 0,
                                    marginTop: "5px",
                                  }}
                                >
                                  Quantité :&nbsp;
                                  <span
                                    style={{
                                      fontFamily: "montserrat-Regular",
                                      color: "#626175",
                                    }}
                                  >
                                    x {i?.prod_quantity}
                                  </span>
                                </p>

                                <p
                                  style={{
                                    fontFamily: "montserrat-Bold",
                                    fontSize: 16,
                                    color: defaultLabelColors.main_font,
                                    margin: 0,
                                    marginTop: 5,
                                  }}
                                >
                                  Dimensions :&nbsp;
                                  {i?.prod_height ? (
                                    <span
                                      style={{
                                        fontFamily: "montserrat-Regular",
                                        color: "#626175",
                                      }}
                                    >
                                      {i?.prod_height} X {i?.prod_width} X{" "}
                                      {i?.prod_length}
                                    </span>
                                  ) : (
                                    <span
                                      style={{
                                        fontFamily: "montserrat-Regular",
                                        color: "#626175",
                                      }}
                                    >
                                      {" "}
                                      - - -{" "}
                                    </span>
                                  )}
                                </p>

                                <p
                                  style={{
                                    fontFamily: "montserrat-Bold",
                                    fontSize: 16,
                                    color: defaultLabelColors.main_font,
                                    margin: 0,
                                    marginTop: "5px",
                                  }}
                                >
                                  Fragile :&nbsp;
                                  <span
                                    style={{
                                      fontFamily: "montserrat-Regular",
                                      color: "#626175",
                                    }}
                                  >
                                    {i?.prod_is_fragile ? "Oui" : "Non"}
                                  </span>
                                </p>
                                <div
                                  style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: 8,
                                  }}
                                >
                                  <p
                                    style={{
                                      fontSize: 14,
                                      fontFamily: "montserrat-Regular",
                                      color: "#4B4A61",
                                      // margin:0
                                    }}
                                  >
                                    Informations complémentaires
                                  </p>
                                  {/* <p
                                    style={{
                                      fontSize: 14,
                                      fontFamily: "montserrat-Regular",
                                      color: "#000000",
                                      margin: 0,
                                    }}
                                  >
                                    {i?.prod_desc
                                      ? i?.prod_desc
                                      : "No complémentaires"}
                                  </p> */}
                                  <p
                                    style={{
                                      fontSize: 14,
                                      fontFamily: "montserrat-Regular",
                                      color: "#000000",
                                      margin: 0,
                                      maxHeight: height,
                                      overflow: "hidden",
                                      transition: "max-height 0.4s ease",
                                    }}
                                    ref={contentRef}
                                  >
                                    {i?.prod_desc
                                      ? showMore
                                        ? i?.prod_desc
                                        : i?.prod_desc?.slice(0, 150) +
                                          (i?.prod_desc.length > 150
                                            ? "..."
                                            : "")
                                      : "No complémentaires"}
                                  </p>

                                  {i?.prod_desc &&
                                    i?.prod_desc.length > 150 && (
                                      <button
                                        onClick={() => setShowMore(!showMore)}
                                        style={{
                                          fontSize: 14,
                                          fontFamily: "montserrat-Medium",
                                          color: "#0000000",
                                          background: "none",
                                          border: "none",
                                          cursor: "pointer",
                                          padding: 0,
                                          textAlign: "center",
                                          textDecoration: "underline",
                                        }}
                                      >
                                        {showMore ? "Voir moins" : "Voir plus"}
                                      </button>
                                    )}
                                </div>
                              </div>
                            </AccordionDetails>
                          </Accordion>
                        ))}
                      </>
                    ) : (
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          gap: 8,
                        }}
                      >
                        <p
                          style={{
                            fontSize: 14,
                            fontFamily: "montserrat-Regular",
                            color: "#4B4A61",
                            margin: 0,
                          }}
                        >
                          Produits & dimension
                        </p>

                        <p
                          style={{
                            fontFamily: "montserrat-Bold",
                            fontSize: 16,
                            color: defaultLabelColors.main_font,
                            margin: 0,
                          }}
                        >
                          {transSizes(
                            state?.jobDetails?.shipment_items?.[0]?.cat_name ??
                              ""
                          )}
                          {state?.jobDetails?.prod_quantity > 1 ? "s" : null} ·
                          &nbsp;
                          <span
                            style={{
                              fontFamily: "montserrat-Regular",
                              color: "#626175",
                            }}
                          >
                            {transSizesForWeight(
                              state?.jobDetails?.shipment_items?.[0]?.cat_name
                            )}
                          </span>
                        </p>
                        <p
                          style={{
                            fontSize: 16,
                            fontFamily: "montserrat-Bold",
                            margin: 0,
                            color: "#080626",
                          }}
                        >
                          Quantité :&nbsp;
                          <span
                            style={{
                              fontSize: 16,
                              fontFamily: "montserrat-Regular",
                              margin: 0,
                              color: "#626175",
                            }}
                          >
                            {`x ${state?.jobDetails?.shipment_items?.[0]?.prod_quantity}`}
                          </span>
                        </p>
                        <p
                          style={{
                            fontSize: 16,
                            fontFamily: "montserrat-Bold",
                            margin: 0,
                            color: "#080626",
                          }}
                        >
                          Dimensions :&nbsp;
                          <span
                            style={{
                              fontSize: 16,
                              fontFamily: "montserrat-Regular",
                              margin: 0,
                              color: "#626175",
                            }}
                          >
                            {state?.jobDetails?.shipment_items?.[0]
                              ?.prod_length ?? 0}{" "}
                            x{""}
                            {state?.jobDetails?.shipment_items?.[0]
                              ?.prod_height ?? 0}{" "}
                            x{""}
                            {state?.jobDetails?.shipment_items?.[0]
                              ?.prod_width ?? 0}
                          </span>
                        </p>
                        <p
                          style={{
                            fontSize: 16,
                            fontFamily: "montserrat-Bold",
                            margin: 0,
                            color: "#080626",
                          }}
                        >
                          Fragile :&nbsp;
                          <span
                            style={{
                              fontSize: 16,
                              fontFamily: "montserrat-Regular",
                              margin: 0,
                              color: "#626175",
                            }}
                          >
                            {state?.jobDetails?.shipment_items?.[0]
                              ?.prod_is_fragile
                              ? "Oui"
                              : "Non"}
                          </span>
                        </p>
                      </div>
                    )}
                  </div>

                  {state?.jobDetails?.shipment_items?.length === 1 && (
                    <div
                      style={{
                        padding: "0px 20px 20px 20px",
                        gap: 10,
                        marginTop: "10px",
                      }}
                    >
                      <p
                        style={{
                          fontFamily: "montserrat-Regular",
                          color: "#4B4A61",
                          fontSize: "14px",
                        }}
                      >
                        Informations complémentaires
                      </p>
                      <p
                        style={{
                          fontSize: 14,
                          fontFamily: "montserrat-Regular",
                          color: "#000000",
                          margin: 0,
                          maxHeight: height,
                          overflow: "hidden",
                          transition: "max-height 0.4s ease",
                        }}
                        ref={contentRef}
                      >
                        {state?.jobDetails?.shipment_items?.[0]?.prod_desc
                          ? showMore
                            ? state?.jobDetails?.shipment_items?.[0]?.prod_desc
                            : state?.jobDetails?.shipment_items?.[0]?.prod_desc?.slice(
                                0,
                                150
                              ) +
                              (state?.jobDetails?.shipment_items?.[0]
                                ?.prod_desc > 150
                                ? "..."
                                : "")
                          : "No complémentaires"}
                      </p>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        {state?.jobDetails?.shipment_items?.[0]?.prod_desc &&
                          state?.jobDetails?.shipment_items?.[0]?.prod_desc
                            .length > 150 && (
                            <button
                              onClick={() => setShowMore(!showMore)}
                              style={{
                                fontSize: 14,
                                fontFamily: "montserrat-Medium",
                                color: "#0000000",
                                background: "none",
                                border: "none",
                                cursor: "pointer",
                                padding: 0,
                                textAlign: "center",

                                textDecoration: "underline",
                              }}
                            >
                              {showMore ? "Voir moins" : "Voir plus"}
                            </button>
                          )}
                      </div>
                    </div>
                  )}
                </>
              )}
            </DialogContent>
          }
        />

        <Dialog
          open={state?.show_accept_success}
          onClose={() => {
            setState({ show_accept_success: false });
          }}
          PaperProps={{
            sx: {
              borderRadius: "16px", // <- Border radius applied here
            },
          }}
          maxWidth="md"
          fullWidth
        >
          <DialogContent dividers style={{ padding: "50px" }}>
            <Grid
              container
              spacing={2}
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "column",
                rowGap: "20px",
              }}
            >
              <div
                style={{
                  fontFamily: "montserrat-Bold",
                  color: defaultLabelColors.main_font_brown,
                  fontSize: 28,
                  textAlign: "center",
                }}
              >
                Félicitation vous venez de valider une offre !
                <p
                  style={{
                    fontFamily: "montserrat-Regular",
                    color: defaultLabelColors.main_font_grey,
                    fontSize: 16,
                  }}
                >
                  Vous pouvez désormais discuter avec l’expéditeur
                </p>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <HandClapImage height={300} width={300} />
              </div>
              <div>
                <CustomButton
                  classesNames={"contained_button_for_nego"}
                  value={" Accéder à la messagerie"}
                  onClick={() => {
                    navigate(`/chat/1/${state?.jobDetails?.id}`);
                  }}
                />
              </div>
            </Grid>
          </DialogContent>
        </Dialog>

        <DraggableDialog
          maxWidth={"md"}
          open={state?.openLoginDialog}
          handleClose={() => {
            setState({ openLoginDialog: false });
          }}
          classes={classes}
          dialogBody={
            <DialogContent
              style={{
                display: "flex",
                background: defaultLabelColors.main_background_new,
              }}
              dividers
            >
              <Grid container spacing={2}>
                <Grid xs={12} item>
                  <AuthAction
                    {...state}
                    {...props}
                    handleCloseLoginPage={handleCloseLoginPage}
                  />
                </Grid>
              </Grid>
            </DialogContent>
          }
        />
        <Dialog
          // fullScreen={fullScreen}
          open={state.acceptWarning}
          onClose={() => setState({ acceptWarning: false })}
          maxWidth="sm"
          PaperProps={{
            sx: {
              borderRadius: "16px", // <- Border radius applied here
            },
          }}
          fullWidth
          title="Accepter l’offre"
        >
          <DialogContent dividers>
            <div
              style={{
                display: "flex",
                alignItems: "flex-start",
                marginTop: "10px",
                marginBottom: "40px",
              }}
            >
              <p
                onClick={() => {
                  setState({ acceptWarning: false });
                }}
                style={{
                  flex: 1,
                  color: defaultLabelColors.main_font,
                  fontSize: 20,
                  fontFamily: "montserrat-Bold",
                  margin: 0,
                }}
              >
                {" "}
                Accepter l’offre
              </p>

              <Close
                onClick={() => {
                  setState({ acceptWarning: false });
                }}
                style={{ cursor: "pointer" }}
              />
            </div>
            <Grid spacing={2}>
              <Grid xs={12} item>
                <p
                  style={{
                    fontFamily: "montserrat-SemiBold",
                    fontSize: 16,
                    color: "#000",
                  }}
                >
                  Vous êtes sûr le point d’accepter une offre d’un montant de{" "}
                  {state?.jobDetails?.ship_price ?? "0.00"}€.
                </p>
                <p
                  style={{
                    fontFamily: "montserrat-SemiBold",
                    fontSize: 16,
                    color: "#000",
                  }}
                >
                  Êtes-vous sûr ?
                </p>
                <div style={{ width: "100%", gap: "10px", display: "flex" }}>
                  <CustomButton
                    classesNames={"outline_button_for_nego"}
                    value={"Retour"}
                    style={{ width: "100%" }}
                    onClick={() => {
                      setState({ acceptWarning: false });
                    }}
                  />
                  <CustomButton
                    classesNames={"contained_button_for_nego"}
                    value={"Valider"}
                    onClick={handleAcceptJob}
                    style={{ width: "100%" }}
                  />
                </div>
              </Grid>
            </Grid>
          </DialogContent>
        </Dialog>
        <CustomDialogBox
          Width={1215}
          open={state?.image_box}
          handleClose={() => {
            setState({ image_box: false });
            setCurrentIndex(0);
          }}
          classes={classes}
          dialogBody={
            <DialogContent style={{}}>
              <div
                style={{
                  //  bottom:"50%",
                  display: "flex",
                  height: 500,
                }}
              >
                <IconButton
                  // variant="contained"
                  onClick={() => handlePrevious()}
                >
                  <svg
                    width="30"
                    height="30"
                    viewBox="0 0 38 38"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clip-path="url(#clip0_347_53392)">
                      <rect
                        x="38"
                        y="38"
                        width="38"
                        height="38"
                        rx="19"
                        transform="rotate(180 38 38)"
                        fill="white"
                        fill-opacity="0.7"
                      />
                      <path
                        d="M22 13L16 19L22 25"
                        stroke="#78778A"
                        stroke-width="2"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      />
                    </g>
                    <defs>
                      <clipPath id="clip0_347_53392">
                        <rect
                          width="38"
                          height="38"
                          fill="white"
                          transform="translate(38 38) rotate(180)"
                        />
                      </clipPath>
                    </defs>
                  </svg>
                </IconButton>
                <div
                  style={{
                    backgroundImage: `url(${encodeURI(
                      state?.image_slider?.[currentIndex] ?? no_image_url
                    )})`,
                    height: "500px",
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat",
                    backgroundSize: "cover",
                    borderRadius: 16,
                    width: "100%",
                  }}
                ></div>
                <IconButton onClick={() => handleNext()}>
                  <svg
                    width="30"
                    height="30"
                    viewBox="0 0 38 38"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <g clip-path="url(#clip0_347_53387)">
                      <g clip-path="url(#clip1_347_53387)">
                        <rect
                          width="38"
                          height="38"
                          rx="19"
                          fill="white"
                          fill-opacity="0.7"
                        />
                        <path
                          d="M16 25L22 19L16 13"
                          stroke="#78778A"
                          stroke-width="2"
                          stroke-linecap="round"
                          stroke-linejoin="round"
                        />
                      </g>
                    </g>
                    <defs>
                      <clipPath id="clip0_347_53387">
                        <rect width="38" height="38" fill="white" />
                      </clipPath>
                      <clipPath id="clip1_347_53387">
                        <rect width="38" height="38" rx="19" fill="white" />
                      </clipPath>
                    </defs>
                  </svg>
                </IconButton>
              </div>
            </DialogContent>
          }
        />
      </div>
      <div className="mobile-screen">
        <MobileResponsive />
      </div>
    </>
  );
}

export default AllAnounces;
